import { get, post, patch, del } from './apiClient';

// Types
export interface AIReferenceEvaluation {
  evaluation: {
    fit_value: number;
    fit_description: string;
    summary: string;
    conclusion: string;
  };
  insights: {
    key_considerations: string[];
    positive_highlights: string[];
    first_days_initiatives: string[];
  };
}
export interface Candidate {
  id: string;
  jobId: string;
  full_name: string;
  email: string;
  phone?: string;
  linkedin?: string;
  status: string;
  references?: Reference[];
  created_at: string;
  sent_email_at?: string;
  form_filled_at?: string;
}

export interface Reference {
  id: string;
  candidate_id: string;
  full_name: string;
  company: string;
  relationship_type: string;
  department: string;
  email: string;
  phone?: string;
  years_worked: number;
  seniority: string;
  filled_form_at?: string;
  sent_email_at?: string;
}

export interface CandidateCreateDTO {
  jobId: string;
  full_name: string;
  email: string;
  phone?: string;
  linkedin?: string;
  status: string;
  references?: ReferenceCreateDTO[];
}

export interface ReferenceCreateDTO {
  full_name: string;
  company: string;
  relationship_type: string;
  department: string;
  email: string;
  phone?: string;
  years_worked: number;
  seniority: string;
}

export interface CandidateUpdateDTO {
  jobId?: string;
  full_name?: string;
  email?: string;
  phone?: string;
  linkedin?: string;
  status?: string;
  references?: ReferenceUpdateDTO[];
}

export interface ReferenceUpdateDTO {
  full_name?: string;
  company?: string;
  relationship_type?: string;
  department?: string;
  email?: string;
  phone?: string;
  years_worked?: number;
  seniority?: string;
}

// API functions
export const candidatesApi = {
  // Get all candidates
  getAll: async (): Promise<Candidate[]> => {
    return get<Candidate[]>('/candidates/');
  },

  // Get a single candidate by ID
  getById: async (candidateId: string): Promise<Candidate> => {
    return get<Candidate>(`/candidates/${candidateId}`);
  },

  // Create a new candidate
  create: async (candidateData: CandidateCreateDTO): Promise<Candidate> => {
    return post<Candidate>('/candidates/', candidateData);
  },

  // Update a candidate
  update: async (candidateId: string, candidateData: CandidateUpdateDTO): Promise<Candidate> => {
    return patch<Candidate>(`/candidates/${candidateId}`, candidateData);
  },

  // Delete a candidate
  delete: async (candidateId: string): Promise<void> => {
    return del<void>(`/candidates/${candidateId}`);
  },
  
  // Send email to candidate
  sendEmail: async (candidateId: string): Promise<void> => {
    return post<void>(`/candidates/${candidateId}/send-email`, '');
  },
  
  // Evaluate candidate references with AI
  evaluateWithAI: async (candidateId: string): Promise<AIReferenceEvaluation> => {
    return post<AIReferenceEvaluation>(`/ai/summarize-references/${candidateId}`, {});
  }
};